import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledRadioButtonGroup = styled.fieldset`
  padding: 0;
  margin: 0;
  border: none;
`;

const Legend = styled.legend`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.39;
  letter-spacing: 0.2px;
  margin-bottom: 10px;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
`;

const Required = styled.span`
  color: ${p => p.theme.colors.alert};
`;

const ErrorMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin-top: 10px;
`;

export default function RadioButtonGroup({
  legend,
  isRequired,
  error,
  touched,
  children
}) {
  return (
    <StyledRadioButtonGroup>
      <Legend>
        {legend} {isRequired && <Required>*</Required>}
      </Legend>

      <Grid>{children}</Grid>

      {touched && error && <ErrorMessage>{error}</ErrorMessage>}
    </StyledRadioButtonGroup>
  );
}

RadioButtonGroup.propTypes = {
  legend: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  touched: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

RadioButtonGroup.defaultProps = {
  isRequired: false,
  touched: false
};
